import View from './View';
import { IconButtonProps } from '../IconButton/types';

export { default as View, getSubactionButtonStyles } from './View';
export const useViewModel = (props: IconButtonProps): IconButtonProps => props;

export default View;
